import React, { useState, useEffect } from "react";
import { Collapse, Button } from "antd";
import KitProductItem from "./KitProductItem";
import { PlusOutlined } from "@ant-design/icons";

const KitProductList = ({ kitProduct, form , setInnerProducts}) => {
  const [primaryProduct, setPrimaryProduct] = useState([]);

  useEffect(() => {    
    if (kitProduct?.bc_secondary_sku) {
      const initializedProducts = [];

      // If bc_primary_sku exists, add it first
      if (kitProduct.bc_primary_sku) {
        let item = kitProduct.bc_primary_sku;
        initializedProducts.push({
          id: item.id,
          key: item.name,
          value: item.value,
          name: item.prod_name,
          image: null,
          is_primary: true,
          msrp:kitProduct.currency_symbol +''+ item.msrp,
          sale_price: kitProduct.currency_symbol +''+ item.sale_price,
          store_id: kitProduct.store_id,
          currency_symbol: kitProduct.currency_symbol
        });
      }

      // Now map through bc_secondary_sku
      const secondaryProducts = kitProduct.bc_secondary_sku.map((item) => {
        const matchedImage = kitProduct.images?.find((img) =>
          img.description.includes(item.value)
        );        
        
        return {
          id: item.id,
          key: item.name,
          value: item.value,
          image: matchedImage || null,
          name: item.prod_name,
          is_primary: false,
          mainImage: item.image,
          msrp:kitProduct.currency_symbol +''+ item.msrp,
          sale_price: kitProduct.currency_symbol +''+ item.sale_price,
          store_id:kitProduct.store_id
        };
      });
      initializedProducts.push(...secondaryProducts);      
      

      setPrimaryProduct(initializedProducts);
    }
    if(primaryProduct){
      setInnerProducts(primaryProduct)
    }


  }, [kitProduct]);

  const addProduct = () => {
    setPrimaryProduct([
      ...primaryProduct,
      {
        id: Date.now(),
        name: "New Product",
        value: "",
        editable: true,
        store_id: kitProduct.store_id,
      },
    ]);
  };

  const removeProduct = (id) => {
    setPrimaryProduct(primaryProduct.filter((product) => product.id !== id));
  };

  const updateProduct = (id, updatedFields) => {
    setPrimaryProduct(
      primaryProduct.map((product) =>
        product.id === id ? { ...product, ...updatedFields } : product
      )
    );
  };
  const items = [
    {
      key: "secondaryKitProducts",
      label: `Kit Products (${primaryProduct.length})`,
      children: (
        <>
          {primaryProduct.map((product) => (
            <div key={product?.id || Math.random()} 
            className={`${!product.name ? 'ProductRed' : ''}`}
          >
              <KitProductItem
                kitProduct={primaryProduct}
                product={product}
                onRemove={removeProduct}
                onUpdate={updateProduct}
                defaultImage={product.image}
                mainImage={product.mainImage}
                form={form}
                setProduct={setInnerProducts}
              />
            </div>
          ))}
          <Button
            className="addBtn"
            onClick={addProduct}
            icon={<PlusOutlined />}
          >
            Add Product
          </Button>
        </>
      ),
    },
  ];

  return (
    <Collapse
      items={items}
      defaultActiveKey={["secondaryKitProducts"]}
      className="ProductDetailsCollapse"
    />
  );
};

export default KitProductList;
